import { useStore as useZustandStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
export function createConnectionStore(deps) {
    const store = createStore()(() => ({
        status: { state: 'disconnected' },
        lastError: null,
        reconnectEnabled: false,
        reconnectAttempt: 0,
    }));
    const actions = {
        async connect(opts) {
            store.setState({ lastError: null });
            const r = await deps.io.connect(opts);
            if (r.kind === 'err') {
                store.setState({ lastError: r.error });
            }
            return r;
        },
        async disconnect() {
            await deps.io.disconnect();
        },
        setReconnectEnabled(enabled) {
            store.setState({ reconnectEnabled: enabled });
        },
    };
    const internal = {
        _updateStatus(s) {
            store.setState({ status: s });
        },
        _clearError() {
            store.setState({ lastError: null });
        },
    };
    return { store, actions, internal };
}
export function useConnectionStore(store, selector) {
    return useZustandStore(store, selector);
}
//# sourceMappingURL=connection-store.js.map